import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorize-page',
  templateUrl: './unauthorize-page.component.html',
  styleUrls: ['./unauthorize-page.component.scss']
})
export class UnauthorizePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
